<template>
  <b-modal
    id="modal-movement-instrument"
    :title="$t('sidebar.movement')"
    cancel-variant="outline-secondary"
    :ok-title="$t('general.save')"
    ok-variant="success"
    :cancel-title="$t('cancel')"
    centered
    size="xl"
    no-close-on-backdrop
    @ok="onSubmit"
    @show="onShow"
    :ok-disabled="goods.length == 0"
  >
    <b-table
      class="table-bordered border min-h-10vw"
      :fields="fields"
      :items="GET_APPLICATIONS_INSTRUMENT_ID.objects"
      show-empty
      hover
      responsive
      :empty-text="$t('empty_text')"
    >
      <template #head()="props">
        <span>{{ $t(props.label) }}</span>
      </template>

      <template #cell(index)="{ index }">
        <span>{{ index + 1 }}</span>
      </template>


      <template #cell(titlePermishin)="data">
        <div class="d-flex justify-content-center">
          <b-button
            :disabled="movement[data.index].count <= 0"
            size="sm"
            variant="primary"
            class="mr-50"
            @click="minusWriteOffAmount(data.index)"
          >
            <feather-icon
              icon="MinusIcon"
              size="15"
            />
          </b-button>



          <b-form-input
            v-model="movement[data.index].count"
            min="0"
            :max="data.item.count2"
            @input="formatPrice(movement[data.index].count, 'count', data.index)"
            onkeypress="return /[0-9,/.]/i.test(event.key)"
            style="width: 120px"
            placeholder=""
            @change="onCountChange(data)"
          />



          <b-button
            :disabled="disableCheckboxIfNeeded(data)"
            size="sm"
            variant="primary"
            class="ml-50"
            @click="addWriteOffAmount(data.index)"
          >
            <feather-icon
              icon="PlusIcon"
              size="15"
            />
          </b-button>
        </div>
      </template>




      <template #cell(remainder)="data">
        <v-select
          v-model="movement[data.index].remainder2"
          style="min-width: 250px"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :clearable="false"
          :get-option-label="(option) => `${option.storage__title} | ${option.sum_remainder}`" 
          :options="data.item.remainder_full"
          @option:selected="onChecked(data, 'onSelectChanged')"
        />
      </template>




      <template #cell(actions)="data">
        <b-form-checkbox
          :disabled="disableCheckboxIfNeeded(data)"
            v-model="movement[data.index].checked"
            @change="onChecked(data)"
        >
        </b-form-checkbox>
      </template>



    </b-table>
  </b-modal>
</template>

<script>
import {
  BButton,
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BTable,
  BFormSpinbutton,
  BFormCheckbox
} from "bootstrap-vue";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "@core/utils/validations/validations";
import objective from "@/mixins/objective";

export default {
  components: {
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BRow,
    ValidationProvider,
    ValidationObserver,
    BModal,
    BTable,
    BFormSpinbutton,
    BButton,
    BCard,
    BFormCheckbox,
  },
  mixins: [objective],
  data() {
    return {
      required,


      // ===============  PRIMARY_DATA_SECTION START ===============
      goods: [],
      movement: [{ count: 0, remainder: 0 }],
      fields: [
        {
          label: "№",
          key: "index",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "reference.categoriya",
          key: "instrument.type.category.title",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "courses.type",
          key: "instrument.type.title",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "namee",
          key: "instrument.title",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          label: "move_request",
          key: "titlePermishin",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: { width: "20%" },
        },
        // {
        //   label: 'Стартовое количество',
        //   key: 'start_count',
        //   thClass: 'text-center',
        //   tdClass: 'text-center',
        // },
        {
          label: "remaining_stock",
          key: "remainder",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: { width: "20%" },
        },
        {
          label: "actions",
          key: "actions",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: { width: "5%" },
        },
      ],
      // ===============  PRIMARY_DATA_SECTION END ===============





    }
  },
  computed: {
    ...mapGetters("application", ["GET_APPLICATIONS_INSTRUMENT_ID"]),
  },
  watch: {
  },
  async mounted(){
    

    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.FETCH_APPLICATIONS_INSTRUMENT_ID(this.$route.params.id);
    // ===============  PRIMARY_REQUESTS_SECTION END ===============



  },
  methods: {
    ...mapActions("application", [
      "CREATE_APPLICATION_MOVEMENT_FOR_INSTRUMENT",
      "FETCH_APPLICATIONS_INSTRUMENT_ID",
    ]),




    onShow(){
      this.movement = JSON.parse(JSON.stringify(this.GET_APPLICATIONS_INSTRUMENT_ID.objects))

      this.movement.forEach((elem) => {
        if(parseFloat(elem.count.toString().replace(/,/g, "")) == 0){
          elem.checked = false
        }
        // else if((elem.remainder - elem.count) > 0){
        //   elem.checked = true
        // }else{
        //   elem.checked = false
        // }
      })


      this.GET_APPLICATIONS_INSTRUMENT_ID.objects.forEach((elem, index) => {
        elem.count2 = elem.count 
      })


      this.movement.forEach((elem, index) => {
        this.formatPrice(elem.count, 'count', index)
      })
    },





    async onChecked(data, type){
      await this.disableCheckboxIfNeeded(data)
      this.goods = []
      this.movement.forEach((elem) => {
        if(elem.checked && elem.remainder2 && elem.remainder2.storage_id){
          this.goods.push({storage: elem.remainder2.storage_id, instrument_id: elem.instrument.id, count: parseFloat(elem.count.toString().replace(/,/g, ""))})
        }
      })


      if(type && type == 'onSelectChanged'){
        this.$set(this.movement[data.index], 'checked', false)
        // this.movement[data.index].checked = false  // not reactive
      }
    },    





    onCountChange(data){
      if(parseFloat(this.movement[data.index].count.toString().replace(/,/g, "")) > this.movement[data.index].remainder2.sum_remainder){
        this.movement[data.index].checked = false
      }
    },





    disableCheckboxIfNeeded(data){
      if(this.movement[data.index].remainder2 && this.movement[data.index].remainder2.sum_remainder){
        if(parseFloat(this.movement[data.index].count.toString().replace(/,/g, ""))
         <= parseFloat(this.movement[data.index].remainder2.sum_remainder.toString().replace(/,/g, ""))){
          return false          
        }else{

          this.goods = []
          this.movement.forEach((elem) => {
            if(elem.checked && elem.remainder2 && elem.remainder2.storage_id){
              this.goods.push({storage: elem.remainder2.storage_id, instrument_id: elem.instrument.id, count: parseFloat(elem.count.toString().replace(/,/g, ""))})
            }
          })
          
          this.$set(this.movement[data.index], 'checked', false)
          return true
        }
      }else{
        // this.movement[data.index].checked = false
        return true
      }

    },
    



    // ===============  ON_SUBMIT_SECTION START ===============
    async onSubmit() {
      await this.CREATE_APPLICATION_MOVEMENT_FOR_INSTRUMENT({
        requirement: this.$route.params.id,
        instruments: this.goods,
      })
        .then(async () => {
          await this.FETCH_APPLICATIONS_INSTRUMENT_ID(this.$route.params.id);
          this.$emit("refreshCall", true);
          this.$_okToast("success");
        })
        .catch(() => {
          this.$_errToast("error");
        });
    },
    // ===============  ON_SUBMIT_SECTION START ===============




      // ===============  SEARCH_SECTION START ===============
    formatPrice(value, type, index) {
      if (value) {
        let currency = value.toString().replace(/,/g, "");
        currency = parseFloat(currency);
        currency = new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format(currency);
        

        if (type == "count") {
          this.movement[index].count = currency;
        }
      }
      return 0;
    },
    // ===============  SEARCH_SECTION END ===============



    addWriteOffAmount(index){
      let a = this.movement[index].count.toString().replace(/,/g, "");
      a++;
      this.formatPrice(a, 'count', index)
    },


    minusWriteOffAmount(index){
      let a = this.movement[index].count.toString().replace(/,/g, "");
      a--;
      this.formatPrice(a, 'count', index)
    },







    
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.material .vs--disabled .vs__dropdown-toggle,
[dir] .vs--disabled .vs__clear,
[dir] .vs--disabled .vs__search,
[dir] .vs--disabled .vs__selected,
[dir] .vs--disabled .vs__open-indicator {
  cursor: not-allowed;
  background-color: transparent !important;
}
</style>
